import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';

import { ValidatorEditorBase } from '../validator-editor-base/validator-editor-base';

@Component({
  selector: 'df-string-length-validator-editor',
  templateUrl: './string-length-validator-editor.component.html',
  styleUrls: ['./string-length-validator-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StringLengthValidatorEditorComponent extends ValidatorEditorBase<{ min: number; max: number }>
  implements OnInit {
  get min(): number {
    return this._min;
  }
  set min(val: number) {
    this.setMinValue(val);
  }

  get max(): number {
    return this._max;
  }
  set max(val: number) {
    this.setMaxValue(val);
  }

  private _min: number;
  private _max: number;
  @ViewChild(ElementRef) minInput: ElementRef;
  @ViewChild(ElementRef) maxInput: ElementRef;

  ngOnInit() {
    if (!this.caption) {
      this.caption = 'å­ç¬¦é¿åº¦';
    }
  }

  setMinValue(val: number) {
    this._min = val;
    if (this.control && this.model) {
      if (this.model.data.min !== val) {
        this.model.data.min = val;
        this.emitModelChange();
      }
    }
  }

  setMaxValue(val: number) {
    this._max = val;
    if (this.control && this.model) {
      if (this.model.data.max !== val) {
        this.model.data.max = val;
        this.emitModelChange();
      }
    }
  }

  minBlur() {
    if (this.max !== undefined) {
      if (this.min > this.max) {
        this.min = this.max;
      }
    }
  }

  maxBlur() {
    // å¤æ­å¤§äºå³ä¾§
    if (this.max !== undefined) {
      if (this.max < this.min) {
        this.max = this.min;
      }
    }
  }

  afterModelInit() {
    this._min = this.model.data.min;
    this._min = this._min < 0 ? undefined : this._min;

    this._max = this.model.data.max;
    this._max = this._max < 0 ? undefined : this._max;
  }

  defaultModelData(): any {
    return { min: undefined, max: undefined };
  }
}
